import { Injectable, signal } from '@angular/core';

/**
 * Session-scoped flag that prevents the {@link jrVerifyUnrepresentedGuard} from
 * repeatedly redirecting to the address-collection page after the judge has
 * already completed that step. Mirrors the subF
 * {@link CheckAddressCompletionService} pattern.
 */
@Injectable({ providedIn: 'root' })
export class JrCheckAddressCompletionService {
  private readonly _isComplete = signal(false);
  readonly isComplete = this._isComplete.asReadonly();

  markComplete(): void {
    this._isComplete.set(true);
  }

  /** Reset when the judge revisits the recipients page. */
  reset(): void {
    this._isComplete.set(false);
  }
}
